import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";

type MapCoordinatesVariables = {
  mapX: number | string;
  mapY: number | string;
  hideMap?: boolean;
};

type MapCoordinatesMeta = {
  teamId: number;
  leagueId: number;
};

const buildPayload = (
  variables: MapCoordinatesVariables,
  meta: MapCoordinatesMeta
) => ({
  ...variables,
  ...meta,
  mapX: Number(variables.mapX),
  mapY: Number(variables.mapY),
  hideMap: Boolean(variables.hideMap),
});

export const clubsMapCoordinatesDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    update: async ({ variables, meta }) => {
      const updateUrl = "/cms/team/mapCoordinates";

      try {
        const { data } = await httpClient.post(
          updateUrl,
          buildPayload(
            variables as MapCoordinatesVariables,
            meta as MapCoordinatesMeta
          )
        );

        return {
          data,
        };
      } catch (error) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables, meta }) => {
      const updateUrl = "/cms/team/mapCoordinates";

      try {
        const { data } = await httpClient.post(
          updateUrl,
          buildPayload(
            variables as MapCoordinatesVariables,
            meta as MapCoordinatesMeta
          )
        );

        return {
          data,
        };
      } catch (error) {
        return Promise.reject(error);
      }
    },
  };
